import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SelectedEmployeeState, selectedEmployeeFeatureKey } from '../reducers/selected-employee.reducer';
import * as fromSearchEmployeeMainReducer from '../reducers';
import * as fromSelectedEmployeeReducer from '../reducers/selected-employee.reducer';

export const getEmployeeSearchState = createFeatureSelector<fromSearchEmployeeMainReducer.State, SelectedEmployeeState>(
  fromSearchEmployeeMainReducer.employeeSearchFeatureKey
);

export const getSelectedEmployeeState = createSelector(getEmployeeSearchState, state => state[selectedEmployeeFeatureKey]);

export const getSelectedEmployee = createSelector(getSelectedEmployeeState, fromSelectedEmployeeReducer.getSelectedEmployee);

export const getSelectedEmployeeUserProfileId = createSelector(
  getSelectedEmployeeState,
  fromSelectedEmployeeReducer.getSelectedEmployeeUserProfileId
);
